function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/no-multi-comp */
import classNames from 'classnames';
import * as React from 'react';
import Anchor from '@restart/ui/Anchor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PageItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className,
      style = _ref.style,
      _ref$activeLabel = _ref.activeLabel,
      activeLabel = _ref$activeLabel === void 0 ? '(current)' : _ref$activeLabel,
      children = _ref.children,
      linkStyle = _ref.linkStyle,
      linkClassName = _ref.linkClassName,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? Anchor : _ref$as,
      props = _objectWithoutProperties(_ref, ["active", "disabled", "className", "style", "activeLabel", "children", "linkStyle", "linkClassName", "as"]);

  var Component = active || disabled ? 'span' : as;
  return /*#__PURE__*/_jsx("li", {
    ref: ref,
    style: style,
    className: classNames(className, 'page-item', {
      active: active,
      disabled: disabled
    }),
    children: /*#__PURE__*/_jsxs(Component, _objectSpread(_objectSpread({
      className: classNames('page-link', linkClassName),
      style: linkStyle
    }, props), {}, {
      children: [children, active && activeLabel && /*#__PURE__*/_jsx("span", {
        className: "visually-hidden",
        children: activeLabel
      })]
    }))
  });
});
PageItem.displayName = 'PageItem';
export default PageItem;

function createButton(name, defaultValue) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : name;
  var Button = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var children = _ref2.children,
        props = _objectWithoutProperties(_ref2, ["children"]);

    return /*#__PURE__*/_jsxs(PageItem, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      children: [/*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        children: children || defaultValue
      }), /*#__PURE__*/_jsx("span", {
        className: "visually-hidden",
        children: label
      })]
    }));
  });
  Button.displayName = name;
  return Button;
}

export var First = createButton('First', '«');
export var Prev = createButton('Prev', '‹', 'Previous');
export var Ellipsis = createButton('Ellipsis', '…', 'More');
export var Next = createButton('Next', '›');
export var Last = createButton('Last', '»');